'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _common = require('./common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserState = function () {
    function UserState(user) {
        (0, _classCallCheck3.default)(this, UserState);

        this.nick = user.nick;
        this.host = user.host || '';
        this.username = user.username || '';
        this.realname = user.realname || '';
        this.modes = user.modes || '';
        this.away = user.away || '';
        this.colour = user.colour || '';
        this.account = user.account || '';
        this.buffers = (0, _create2.default)(null);
        this.hasWhois = false;
        this.typingState = (0, _create2.default)(null);
        this.avatar = user.avatar || { small: '', large: '' };
        this.ignore = false;

        _vue2.default.observable(this);

        (0, _common.def)(this, 'actual_host', '', true);
        (0, _common.def)(this, 'helpop', '', true);
        (0, _common.def)(this, 'bot', '', true);
        (0, _common.def)(this, 'server', '', true);
        (0, _common.def)(this, 'server_info', '', true);
        (0, _common.def)(this, 'operator', '', true);
        (0, _common.def)(this, 'channels', '', true);
        (0, _common.def)(this, 'modes', '', true);
        (0, _common.def)(this, 'idle', '', true);
        (0, _common.def)(this, 'logon', '', true);
        (0, _common.def)(this, 'registered_nick', '', true);
        (0, _common.def)(this, 'secure', '', true);
        (0, _common.def)(this, 'special', '', true);
    }

    (0, _createClass3.default)(UserState, [{
        key: 'getColour',
        value: function getColour() {
            if (!this.colour) {
                this.colour = TextFormatting.createNickColour(this.nick);
            }

            return this.colour === 'default' ? '' : this.colour;
        }
    }, {
        key: 'isAway',
        value: function isAway() {
            return !!this.away;
        }
    }, {
        key: 'typingStatus',
        value: function typingStatus(target, status) {
            var _this = this;

            if (!this.typingState[target.toLowerCase()]) {
                _vue2.default.set(this.typingState, target.toLowerCase(), { started: 0, status: '' });
            }

            var typing = this.typingState[target.toLowerCase()];

            if (!status) {
                return this.typingState[target.toLowerCase()] || { status: '' };
            }

            if (typing.timeout) {
                clearTimeout(typing.timeout);
                typing.timeout = null;
            }

            if (status === 'done') {
                _vue2.default.delete(this.typingState, target.toLowerCase());
                return null;
            }

            typing.started = Date.now();
            typing.status = status;

            var timeoutLen = status === 'paused' ? 30000 : 6000;

            typing.timeout = setTimeout(function () {
                return _this.typingStatus(target, 'done');
            }, timeoutLen);

            return typing;
        }
    }]);
    return UserState;
}();

exports.default = UserState;


//////////////////
// WEBPACK FOOTER
// ./src/libs/state/UserState.js
// module id = ecZp
// module chunks = 1